import React, { memo, FC } from 'react'

interface ErrorsListProps {
	projectErrors: string[][] | null
}

const ErrorsList: FC<ErrorsListProps> = memo(({ projectErrors }) => {
	return (
		<div className='errors-list'>
			{projectErrors?.length ? (
				projectErrors.map((errorsBlock, blockIndex) => (
					<React.Fragment key={blockIndex}>
						{errorsBlock.map((textErr: string, i: number) => (
							<div key={`${blockIndex}-${i}-${textErr}`} className='errors-item__desc'>
								<span className='error-icon'></span>
								<span className='errors-item__error-shrt-txt'>{textErr}</span>
							</div>
						))}
					</React.Fragment>
				))
			) : (
				<div className='errors-item__success'>
					<span className='success-icon'></span>
					<span className='errors-item__success-shrt-txt'>Ошибок не обнаружено!</span>
				</div>
			)}
		</div>
	)
})
export { ErrorsList }
